var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnershipArtwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_700",
    x: 6.287,
    y: 51.234,
    width: 497.256,
    height: 304.131,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 16,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_702",
    x: 42.299,
    y: 121.793,
    width: 425.23,
    height: 213.207,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 16,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17234",
    "data-name": "Path 17234",
    d: "M1735.747,1604.8h-120.31c-7.169,0-13.038,8.209-13.038,18.2h0c0,10.029,5.869,18.2,13.038,18.2h120.31c7.169,0,13.038-8.209,13.038-18.2h0c0-10.029-5.869-18.2-13.038-18.2",
    transform: "translate(-1602.4 -1604.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17238",
    "data-name": "Path 17238",
    d: "M1262.2,1641.2h144.528c4.717,0,9.695-8.32,9.695-18.312,0-10.029-4.977-18.089-9.695-18.089H1262.2l.037,5.46,144.156.111c3.269,0,5.98,5.72,5.98,12.666s-2.674,12.666-5.98,12.666l-144.156-.111Z",
    transform: "translate(-1262.2 -1604.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17240",
    "data-name": "Path 17240",
    d: "M1719.1,1519.3H1612.389c-6.352,0-11.589,7.28-11.589,16.158h0c0,8.877,5.2,16.158,11.589,16.158H1719.1c6.352,0,11.589-7.28,11.589-16.158h0c-.037-8.915-5.237-16.158-11.589-16.158",
    transform: "translate(-1600.8 -1519.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17245",
    "data-name": "Path 17245",
    d: "M1467.963,1420.3h89.554c5.349,0,9.732,8.283,9.732,18.386h0c0,10.1-4.383,18.386-9.732,18.386h-89.554c-5.349,0-11.663-7.986-11.663-18.089h0c0-10.1,6.315-18.684,11.663-18.684",
    transform: "translate(-1456.3 -1420.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17266",
    "data-name": "Path 17266",
    d: "M1402.167,1101.575c-3.9,8.58-7.132,28.229-22.881,39.6-7.169,5.163-17.755,11.663-25,13.038-7.057,1.337-10.958-2.3-5.014-9.509.372-.446,2.155-1.895,2.526-2.266,4.457-4.457,10.289-4.717,21.135-16.121,1.226-1.3,16.269-34.8,28.378-42.084,1.263-.854,4.68,11.552.854,17.346",
    transform: "translate(-1346.363 -1084.187)",
    fill: "#2f394e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17267",
    "data-name": "Path 17267",
    d: "M1101.848,1194.094c7.763,13.558-8.915,90.669-11.812,137.434l.446-.037s.371,4.049,3.454,5.72c3.083,1.709,14.523,3.083,16.344,4.829,1.337,1.263,3.529,6.352-14.6,5.869-12.852-.334-19.092.78-20.467-1.337-1.077-1.6-.706-9.509-.446-13.075h-.074c-1.672-31.944,1.3-59.876-4.94-97.466-4.94,22.1-10.177,41.3-13.446,53-1.969,7.057-13.521,38.258-12.555,45.241.223,1.56,7.5,2.266,10.586,4.717,1.3,1.226,3.677,6.352-8.8,6.24s-18.5.743-19.835-1.263c-1.263-1.894,8.1-54.527,8.8-61.956,3.231-32.8,4.234-69.088,8.543-90.446h0c2.229-89.109,49.587-66.154,45.316-12.183-.446,6.129,11.366,6.315,13.483,14.709",
    transform: "translate(-1025.585 -1131.747)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17271",
    "data-name": "Path 17271",
    d: "M1113.5,995.57c3.046-.891,5.943-1.82,8.469-4.606.891-1,2.34-9.546,2.86-9.695,1.931-.669,2.823,5.943,2.823,5.943.3-.334,1.3-.631,1.523-1.709.112-.483-.557-3.194-.111-3.9.3-.52,2.414-2.3,2.86-2.972,3.714-5.5,7.949-11.44,2.934-15.675a5.763,5.763,0,0,0-3.157-1.189,11.928,11.928,0,0,1-4.829-1.226c-12.146-5.72-35.881,3.009-23.364,27.524,1.746,3.38,7.094,7.206,9.992,7.5",
    transform: "translate(-1099.961 -958.855)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.523,
    y1: 0.929,
    x2: 0.456,
    y2: -0.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#031542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#051c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#093066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#115191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#1b7dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24a1fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17275",
    "data-name": "Path 17275",
    d: "M1197.218,1115.859c4.792,10.66,6.835,28.861,19.278,37.255,7.763,3.826,35.918,16.6,37.813,9.992,1.932-6.612-.706-9.472-.706-9.472s-24.069-16.826-27.041-17.829c-2.266-.743-11.44-27.635-17.086-35.064-1.411-1.263-14.338,10.549-12.257,15.118",
    transform: "translate(-1196.992 -1100.647)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17276",
    "data-name": "Path 17276",
    d: "M1081.8,1071.753c-6.314,0-15.3,1.932-19.129,6.389-5.46,6.426-4.123,84.615-2.452,94.606,5.46,14.969,51.742,9.175,65.782,1.226l-2.563-90.334c-9.62-14.635-26.67-11.886-41.639-11.886",
    transform: "translate(-1058.755 -1071.548)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17277",
    "data-name": "Path 17277",
    d: "M1043.172,1103.7c2.563-5.312.594-15.712-4.829-18.052-1.449-.631-5.46-2.563-8.1-1.077-9.286,5.2-22.175,38.3-23.624,50.442-1.189,9.992-3.9,39.187,1.04,47.4,1.523,2.526,5.869.706,7.132-.037,3.194-1.114,3.751-23.141,10.1-44.461,5.2-17.606,15.972-29.418,18.275-34.21",
    transform: "translate(-1004.804 -1084.022)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17279",
    "data-name": "Path 17279",
    d: "M1452.339,1194.457c-7.912,13.781,9.509,93.269,11.96,139.736,5.312-.111,9.917-.186,15.192-.3,1.671-31.944-.966-65.857,5.274-103.409,11.255,34.284,24.441,65.188,37.627,97.838l15.786-1.189c-9.472-36.921-20.5-102.741-27.041-135.167h0c-2.229-89.109-49.587-66.154-45.316-12.183.483,6.092-11.366,6.277-13.483,14.672",
    transform: "translate(-1450.293 -1132.147)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17281",
    "data-name": "Path 17281",
    d: "M1519.811,1085.118c5.2,7.726-10.066,40.747-5.72,80.083-24.292,4.16-46.5,2.3-60.991-2.3.668-16.009,2.451-78.894,16.641-84.651,17.235-4.829,42.938-3.752,50.07,6.871",
    transform: "translate(-1453.1 -1075.496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17286",
    "data-name": "Path 17286",
    d: "M1574.415,1087.9c13.372,4.829,26.818,44.721,23.289,55.271-2.972,8.58-35.064,14.449-42.456,11.329-3.492-1.448-4.495-1.783-5.5-4.123-.594-1.374-1.226-3.492,1.709-4.792,7.837-3.454,26.818-9.695,27.264-11.812.557-4.123-19.612-37.181-4.309-45.873",
    transform: "translate(-1549.249 -1087.9)",
    fill: "#23a19f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17287",
    "data-name": "Path 17287",
    d: "M1506.606,985.966c6.129,2.266,12.369-2.043,16.2,1.523,1.894,1.783,2.08,4.606.743,9.212-.409,1.337-1,2.377,1.04,1.114.928-.594,2.526-1.411,3.12-1.04,1.374.854,1,3.046.074,3.863-.408.371-1.188.929-1.188.929,7.615-2.414,9.991-9.806,9.212-15.452-1.969-14.263-12.406-15.526-20.318-14.635-3.863.446-7.429-1.969-9.992-.706-5.906,2.9-5.46,12.369,1.114,15.192",
    transform: "translate(-1501.351 -970.405)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-partnership_artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partnership_artwork",
    clipPath: "url(#clip-partnership_artwork)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536",
    transform: "translate(22686 16738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(-22899.174 -17040.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(185.365 314.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_security_o890",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M570.5,287.955c-12.263,25.3-37.162,42.211-62.965,53.366C472.8,356.343,434.541,362.3,396.812,359.782q-9.918-.66-19.776-2.109a249.424,249.424,0,0,1-66.122-19.255q-9.111-4.1-17.852-8.958a228.38,228.38,0,0,1-27.9-18.249q-3.337-2.548-6.581-5.224c-1.5-1.237-2.986-2.5-4.5-3.729a56.731,56.731,0,0,0-10.117-6.891,36.138,36.138,0,0,0-3.388-1.5c-11.575-4.4-24.922-2.741-36.973.692-9.166,2.612-18.1,6.189-27.257,8.741a90.447,90.447,0,0,1-12.42,2.64,66.094,66.094,0,0,1-27.9-2.451l-.771-.24q-1.938-.609-3.844-1.334l-.771-.3q-1.846-.711-3.614-1.528l-.771-.351q-1.846-.858-3.614-1.814c-.425-.222-.845-.462-1.26-.688a75.538,75.538,0,0,1-18.073-14.072c-.152-.152-.3-.309-.462-.461-.734-.794-1.454-1.6-2.151-2.428-.258-.3-.517-.609-.771-.923q-1.242-1.514-2.4-3.1c-.115-.152-.226-.309-.337-.462a66.731,66.731,0,0,1-7.781-14.072c-.065-.152-.125-.309-.18-.462q-.923-2.377-1.685-4.832c-.208-.683-.406-1.385-.582-2.068-.06-.2-.115-.411-.166-.614-2.548-10.029-2.838-20.455-2.838-30.82v-3.623c.074-16.767.332-33.82,2.806-50.357a2.1,2.1,0,0,1,.051-.342,157.265,157.265,0,0,1,3.374-16.532,121.957,121.957,0,0,1,5.681-16.753c5.691-13.384,13.966-25.564,23.155-36.852,23.145-28.407,53.5-52.253,89.028-61.179,38.283-9.613,80.831-.4,111.711,24.184,9.415,7.5,17.875,16.37,28.448,22.116,9.23,5,20.035,7.075,29.92,3.138,8.169-3.254,13.486-4.869,22.661-4.375A189.943,189.943,0,0,1,456.343,94c.72.263,1.44.535,2.155.808,46.48,17.782,86.434,53.112,107.2,98.512q.826,1.8,1.6,3.628C579.685,225.867,584.162,259.765,570.5,287.955Z",
    transform: "translate(-50.371 -33.556)",
    fill: "#33475b",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 438.598,
    height: 248.451,
    rx: 10.467,
    transform: "translate(53.398 49.728)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 437.255,
    height: 244.131,
    rx: 10.467,
    transform: "translate(54.095 53.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 437.255,
    height: 244.131,
    rx: 10.467,
    transform: "translate(54.095 53.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 27.81, -12.01)",
    filter: "url(#Rectangle_700)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700-2",
    "data-name": "Rectangle 700",
    width: 437.255,
    height: 244.131,
    rx: 10.467,
    transform: "translate(26.29 65.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M556.228,125.106H123.413a2.22,2.22,0,0,0-2.22,2.22v9.383H558.429v-9.383a2.22,2.22,0,0,0-2.2-2.22Z",
    transform: "translate(-67.098 -74.686)",
    fill: "#33475b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "buttons",
    transform: "translate(59.827 53.221)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 117.342,
    height: 9.96,
    transform: "translate(90.107 83.843)",
    fill: "#0292aa",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 27.81, -12.01)",
    filter: "url(#Rectangle_702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702-2",
    "data-name": "Rectangle 702",
    width: 365.23,
    height: 153.207,
    transform: "translate(62.3 135.79)",
    fill: "#0191aa",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 36.968,
    height: 8.727,
    transform: "translate(418.369 109.033)",
    fill: "#0291aa",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M734.711,697.833s-1.975,2.455-4.615,2.644a2.718,2.718,0,0,0-2.7,2.6s.461,1.5-5.921,3.568c-3.854,1.242-6.277.849-7.689,0,3.632-.378,11.658-2.672,12.461-3.466.965-.965,2.169-3.614,2.986-3.66.568-.037,3.452-1.772,5.183-2.848Z",
    transform: "translate(-333.33 -331.469)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M746.69,413.222h0a10.727,10.727,0,0,1-.263,1.846c0-.171,0-.268-.037-.282C746.252,414.75,746.418,414.043,746.69,413.222Z",
    transform: "translate(-347.954 -204.126)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(145.199 156.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart.Content",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative",
    transform: "translate(0 57.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Jul.Bar",
    d: "M0,0H21a0,0,0,0,1,0,0V23a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(247.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "May.Bar",
    d: "M0,0H20a0,0,0,0,1,0,0V7a4,4,0,0,1-4,4H4A4,4,0,0,1,0,7V0A0,0,0,0,1,0,0Z",
    transform: "translate(165.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Apr.Bar",
    d: "M0,0H21a0,0,0,0,1,0,0V28a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(123.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Apr.Bar-2",
    "data-name": "Apr.Bar",
    d: "M0,0H21a0,0,0,0,1,0,0V28a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(206.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mar.Bar",
    d: "M0,0H21a0,0,0,0,1,0,0V36a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(82.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Feb.Bar",
    d: "M0,0H20a0,0,0,0,1,0,0V20a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(41.61 -0.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Feb.Bar-2",
    "data-name": "Feb.Bar",
    d: "M0,0H21a0,0,0,0,1,0,0V20a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(-0.39 -0.301)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Positive",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Jul.Bar-2",
    "data-name": "Jul.Bar",
    d: "M4,0H17a4,4,0,0,1,4,4V43a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(247.609 14.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Jun.Bar",
    d: "M4,0H17a4,4,0,0,1,4,4V28a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(206.609 29.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "May.Bar-2",
    "data-name": "May.Bar",
    d: "M4,0H16a4,4,0,0,1,4,4V52a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(165.609 5.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Apr.Bar-3",
    "data-name": "Apr.Bar",
    d: "M4,0H17a4,4,0,0,1,4,4V29a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(123.609 28.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mar.Bar-2",
    "data-name": "Mar.Bar",
    d: "M4,0H17a4,4,0,0,1,4,4V18a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(82.609 39.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Feb.Bar-3",
    "data-name": "Feb.Bar",
    d: "M4,0H16a4,4,0,0,1,4,4V39a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(41.609 18.19)",
    fill: "#008faa",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Jan.Bar",
    d: "M4,0H17a4,4,0,0,1,4,4V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(-0.391 0.19)",
    fill: "#008faa",
    opacity: 0.25
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_361_Converted_",
    "data-name": "361 [Converted]",
    transform: "translate(-22884 -17425.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17230",
    "data-name": "Path 17230",
    d: "M1338.979,1177.768s-45.353-20.652-38.63-52.6c6.723-31.981,43.607-28.6,38.63-53.822s-29.2-64.519-5.646-93.121,62.736-11.44,67.639-55.79c3.974-35.733,20.467-61.065,52.485-53.636,29.6,6.872,51.7,29.79,52.262,84.354.594,58.093,41.49,41.75,42.01,84.54.52,43.087-33.8,43.087-47.21,71.985-6.314,13.669,10.177,61.659-38.63,68.122h-122.91Z",
    transform: "translate(-809.473 -117.448)",
    fill: "#52c7a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17231",
    "data-name": "Path 17231",
    d: "M1592.188,928.823s.112.966.3,2.86c.52,5.72,1.56,19.649,1.56,39.076,0,56.793-8.952,160.574-65.485,243.369a2.785,2.785,0,0,0-.26.446h5.906c56.013-83.834,64.742-187.058,64.779-243.814a419.135,419.135,0,0,0-1.857-42.493,2.474,2.474,0,0,0-2.749-2.192,2.448,2.448,0,0,0-2.192,2.749",
    transform: "translate(-953.18 -154.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17232",
    "data-name": "Path 17232",
    d: "M1514.3,1362.334s6.946-39.447,33.727-55.493,54.119-28.564,51.148-54.416c-2.972-25.889,4.346-56.422,47.21-56.979,26.521-.334,16.566-28.3,43.5-33.875,16.38-3.38,27.189,13.706,29.27,30.5,2.377,19.129-8.432,37.924,3.974,53.487,16.121,20.169,22.658,57.8-11.96,68.494s-3.751,43.5-50.924,48.324H1514.3Z",
    transform: "translate(-944.38 -302.014)",
    fill: "#78c7c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17233",
    "data-name": "Path 17233",
    d: "M1795.455,1208.671c-.891,25.109-12.035,60.879-31.126,95.015-19.055,34.135-46.022,66.711-78.226,85.877a2.471,2.471,0,0,0-1,1.151h8.506c31.016-20.095,56.645-51.667,75.068-84.614,19.352-34.73,30.755-70.908,31.758-97.243a2.46,2.46,0,0,0-2.377-2.563,2.491,2.491,0,0,0-2.6,2.377",
    transform: "translate(-1051.738 -330.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(602.644 1023.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    "data-name": "Rectangle 1723",
    width: 146.422,
    height: 36.438,
    transform: "translate(-0.037)",
    fill: "#19afad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17235",
    "data-name": "Path 17235",
    d: "M1786.707,1604.8H1749.6c7.169,0,13.038,8.209,13.038,18.2h0c0,10.029-5.869,18.2-13.038,18.2h37.107c7.169,0,13.038-8.209,13.038-18.2h0c0-10.029-5.869-18.2-13.038-18.2",
    transform: "translate(-1092.28 -580.881)",
    fill: "#23a19f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17236",
    "data-name": "Path 17236",
    d: "M1411.648,1645.032H1270.5c4.049-6.537,5.646-15.786,0-25.332h141.148c3.269,0,5.98,5.72,5.98,12.666-.037,6.946-2.711,12.666-5.98,12.666",
    transform: "translate(-791.138 -590.246)",
    fill: "#edeeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17237",
    "data-name": "Path 17237",
    d: "M1274.14,1632.849a24.729,24.729,0,0,0-3.64-13.149h141.148c3.269,0,5.98,5.72,5.98,12.666v.483Z",
    transform: "translate(-791.138 -590.247)",
    fill: "#e0e0df",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(476.279 1023.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    "data-name": "Rectangle 1724",
    width: 154.26,
    height: 36.438,
    fill: "#19afad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17239",
    "data-name": "Path 17239",
    d: "M1577.215,1633.2h-12c-4.606,2.414-3.269,12-6.017,18.275l7.095-5.2,5.163,4.866c3.974-5.683,1.708-15.415,5.757-17.941",
    transform: "translate(-972.603 -598.732)",
    fill: "#23a19f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(602.049 992.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 129.856,
    height: 32.315,
    transform: "translate(0.037)",
    fill: "#febe44"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17241",
    "data-name": "Path 17241",
    d: "M1431.676,1554.972H1306.5a21.019,21.019,0,0,0,0-22.472h125.176c2.9,0,5.275,5.052,5.275,11.217.037,6.2-2.34,11.255-5.275,11.255",
    transform: "translate(-813.766 -535.436)",
    fill: "#edeeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17242",
    "data-name": "Path 17242",
    d: "M1309.731,1544.163a21.829,21.829,0,0,0-3.231-11.663h125.176c2.9,0,5.275,5.052,5.275,11.217v.446Z",
    transform: "translate(-813.766 -535.436)",
    fill: "#e0e0df",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17243",
    "data-name": "Path 17243",
    d: "M1299.2,1551.678h128.184c4.2,0,8.617-7.354,8.617-16.232s-4.42-16.046-8.617-16.046H1299.2l.037,4.829,127.85.075c2.9,0,5.275,5.052,5.275,11.218s-2.377,11.217-5.275,11.217l-127.85-.075Z",
    transform: "translate(-809.177 -527.202)",
    fill: "#febe44",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17244",
    "data-name": "Path 17244",
    d: "M1775.316,1519.3H1732.6c6.352,0,11.589,7.28,11.589,16.158h0c0,8.877-5.2,16.158-11.589,16.158h42.716c6.352,0,11.589-7.28,11.589-16.158h0c0-8.915-5.2-16.158-11.589-16.158",
    transform: "translate(-1081.595 -527.139)",
    fill: "#eeae36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(548.376 955.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 110.95,
    height: 36.773,
    transform: "translate(0)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17246",
    "data-name": "Path 17246",
    d: "M1711.557,1460.955h105.081a31.34,31.34,0,0,1,0-25.555H1711.557c-2.451,0-4.457,5.757-4.457,12.777.037,7.02,2.006,12.777,4.457,12.777",
    transform: "translate(-1065.567 -474.403)",
    fill: "#edeeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17247",
    "data-name": "Path 17247",
    d: "M1813.926,1448.6a32.886,32.886,0,0,1,2.712-13.3H1711.557c-2.451,0-4.457,5.757-4.457,12.777v.483h106.826Z",
    transform: "translate(-1065.567 -474.34)",
    fill: "#e0e0df",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17248",
    "data-name": "Path 17248",
    d: "M1813.75,1457.073H1706.143c-3.529,0-7.243-8.395-7.243-18.5s3.715-18.275,7.243-18.275H1813.75l-.037,5.5-107.309.111c-2.452,0-4.457,5.757-4.457,12.778s2.006,12.777,4.457,12.777l107.309-.111Z",
    transform: "translate(-1060.412 -464.912)",
    fill: "#465067",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17249",
    "data-name": "Path 17249",
    d: "M1531.332,1420.3h35.844c-5.349,0-9.732,8.283-9.732,18.386h0c0,10.1,4.383,18.386,9.732,18.386h-35.844c-5.349,0-9.732-8.283-9.732-18.386h0c.037-10.14,4.383-18.386,9.732-18.386",
    transform: "translate(-948.969 -464.912)",
    fill: "#465067",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17264",
    "data-name": "Path 17264",
    d: "M1056.235,1008.341c.186.26.334.52.52.817Zm-.631-1.04c.186.3.371.557.557.854Zm-5.052-9.769c.149.334.26.669.409,1C1050.812,998.2,1050.7,997.866,1050.552,997.532Zm-.483-1.189c.149.334.26.706.409,1.04C1050.366,997.049,1050.217,996.715,1050.069,996.343Zm-.409-1.114c.149.371.26.706.409,1.077C1049.92,995.935,1049.771,995.563,1049.66,995.229Zm-1.189-3.529.334,1.114Zm-.371-1.151.334,1.114Q1048.267,991.05,1048.1,990.549Zm-.631-2.452c.111.371.186.743.3,1.114C1047.654,988.84,1047.543,988.469,1047.469,988.1Zm-.3-1.226c.074.371.186.78.26,1.151C1047.357,987.651,1047.246,987.28,1047.171,986.871Zm-.26-1.189c.074.371.149.743.26,1.114A9.8,9.8,0,0,1,1046.911,985.683Zm-.26-1.226.223,1.114C1046.8,985.163,1046.726,984.828,1046.651,984.457Zm-.223-1.3c.074.409.149.78.223,1.189C1046.577,983.937,1046.5,983.566,1046.428,983.157Zm-.371-2.489c.111.817.223,1.672.371,2.489C1046.317,982.34,1046.169,981.523,1046.057,980.668Zm-.26-2.526c.074.817.149,1.672.26,2.489C1045.946,979.814,1045.871,978.96,1045.8,978.142Zm-.223-3.863c.037,1.263.111,2.563.223,3.826C1045.686,976.842,1045.611,975.579,1045.574,974.28Zm66.451-2.154V905.6a66.532,66.532,0,0,0-66.525,66.525c0,.706,0,1.411.037,2.117,0-.409-.037-.854-.037-1.263h66.154l-24.181,60.991Z",
    transform: "translate(-649.712 -141.393)",
    fill: "none",
    stroke: "#b1dff7",
    strokeMiterlimit: 10,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504",
    transform: "translate(507.541 830.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 62.699,
    height: 72.134,
    transform: "translate(-3.069 -0.812)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(388.391 848.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 89.369,
    height: 246.191,
    transform: "translate(-1.146 -29.25)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17268",
    "data-name": "Path 17268",
    d: "M1011.6,1334.009c.223,1.857.928,2.712.483,4.495-.3,1.3.26,3.269.371,4.606.074,1.077-.149,5.46,1.709,5.386a.675.675,0,0,0,.52-.223c.334.817,1.6.074,2.043-.223.446.78,1.82.223,2.192-.26.52,1.3,4.643-.557,3.789-1.894,1-.929.483-1.04.26-2.117a73.655,73.655,0,0,0-2.489-8.654c-.483-.929-1.263-1.746-1.226-2.823Z",
    transform: "translate(-628.404 -409.599)",
    fill: "#f4b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17269",
    "data-name": "Path 17269",
    d: "M1116.917,966.69s12.332-4.606,17.978,4.792c1.412,2.34,3.64,2.712,3.6,5.906a35.447,35.447,0,0,0,.334,5.46c.3,1.709,1.6,4.2,1.894,5.572.334,1.709-2.192,2.637-2.266,3.38-.446,5.943.446,9.4-2.3,10.4-6.909.966-17.866.817-21.061-5.052s-6.054-14.338-5.906-20.021c.149-5.646,4.494-8.8,7.726-10.437",
    transform: "translate(-689.742 -179.082)",
    fill: "#f4b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17270",
    "data-name": "Path 17270",
    d: "M1137.532,1042.724s-.483,3.231.334,4.829-15.489,1.634-15.489,1.634a109.181,109.181,0,0,0-3.826-15.935c-2.526-7.354,18.981,9.472,18.981,9.472",
    transform: "translate(-695.499 -220.46)",
    fill: "#f4b1b1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508",
    transform: "translate(416.017 783.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 48.882,
    height: 40.821,
    transform: "translate(-9.012 -4.106)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17272",
    "data-name": "Path 17272",
    d: "M1140.589,1067.246s-.037-3.046-1.411-3.343-16.083-1.263-17.792-.594l-.186,3.863c0,.037,4.346,1.337,19.389.074",
    transform: "translate(-697.294 -240.377)",
    fill: "#dbdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17273",
    "data-name": "Path 17273",
    d: "M1164.774,1018.45c-.26-1.077-2.9-5.5-3.974-2.192-1.04,3.306,1.6,7.763,3.046,7.355,1.486-.334,1.56-2.414.929-5.163",
    transform: "translate(-722.036 -210.19)",
    fill: "#f4b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17274",
    "data-name": "Path 17274",
    d: "M1342.711,1255.935a6.015,6.015,0,0,1-1.115-1.56s-1.969-1.3-2.191-2.117a2.526,2.526,0,0,0-.223-.594c-.26-.557.669-1.6.446-3.157s-.928-8.506-.928-8.506l4.457.743c4.494-.929,9.657,1.82,10.883,6.2a1.574,1.574,0,0,1,.074.408,13.3,13.3,0,0,1-.112,2.9c0,.26-.037,2.674-.594,3.12a2.313,2.313,0,0,1-2.229.52,5.978,5.978,0,0,1-2.9,1.114,3.493,3.493,0,0,1-3.046.557s-1.6.965-2.526.371",
    transform: "translate(-834.005 -351.583)",
    fill: "#f4b1b1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    transform: "translate(452.058 836.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 61.102,
    height: 70.277,
    transform: "translate(-1.854 -1.169)",
    fill: "#23a19f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512",
    transform: "translate(400.711 825.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    "data-name": "Rectangle 1734",
    width: 68.791,
    height: 118.75,
    transform: "translate(-1.543 -2.544)",
    fill: "#19afad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514",
    transform: "translate(380.672 830.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    "data-name": "Rectangle 1735",
    width: 43.013,
    height: 101.849,
    transform: "translate(-2.082 -0.937)",
    fill: "#19afad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17278",
    "data-name": "Path 17278",
    d: "M1422.541,1655.379h35.51a3.321,3.321,0,0,0,3.269-2.86,4.255,4.255,0,0,0,.037-.706l-1.449-18.646a23.851,23.851,0,0,0-3.529-1.189,3.635,3.635,0,0,1-2.637-2.377c-.037-.074-.037-.186-.074-.26-.817-3.6-5.98-4.718-6.946-1.226-.112.446-.223.892-.334,1.3-.037.111-.037.223-.074.3-.149.743-.26,1.449-.334,2.043v.037a23.7,23.7,0,0,0-.186,2.526c-.483.594-.929,1.188-1.374,1.746-.223.3-.446.557-.669.854-.483.594-.929,1.188-1.374,1.783-.223.26-.408.52-.631.78-.483.632-.966,1.189-1.448,1.746-.223.26-.446.483-.669.706-1.82,1.931-3.677,3.232-5.869,3.529-3.863.52-10.14.966-13.186,6.612a1.119,1.119,0,0,0-.149.371,2.244,2.244,0,0,0,2.117,2.935",
    transform: "translate(-885.308 -594.204)",
    fill: "#2e3545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516",
    transform: "translate(546.145 848.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    width: 93.715,
    height: 231.334,
    transform: "translate(-5.866 -29.287)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17280",
    "data-name": "Path 17280",
    d: "M1626.959,1666.716c.3,5.089,18.349,3.343,21.246,1.82a3.486,3.486,0,0,0,1.672-3.12,21.529,21.529,0,0,0-1.374-7.206c-1.151-3.6-1-3.529-1.783-5.98,0,0,.223-3.974-5.72-5.5-5.906-1.523-8.1,8.395-9.1,10.326-.928,1.746-4.531,4.16-4.9,8.469a4.107,4.107,0,0,0-.037,1.189",
    transform: "translate(-1015.178 -607.138)",
    fill: "#2e3545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518",
    transform: "translate(547.187 827.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 71.911,
    height: 95.98,
    transform: "translate(0 -2.079)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17282",
    "data-name": "Path 17282",
    d: "M1610.159,1171.234c-2.377,13.558-4.495,30.235-2.526,48.213-.854.149-1.708.3-2.526.409-.966-2.934-2.266-8.543-3.009-18.572-1.263-17.346,4.606-39.484,4.606-39.484l3.455,9.434Z",
    transform: "translate(-999.455 -302.43)",
    fill: "#23a19f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17283",
    "data-name": "Path 17283",
    d: "M1559.74,1246.9c-.26,3.714-.446,7.577-.409,11.515-2.972.557-8.32-.26-16.9-.371-10.661-.149-15.155,2.637-15.155,2.637s-1.337-6.612-.854-7.8,9.621-3.38,14.412-4.569c4.271-1.114,14.226-1.114,18.906-1.411",
    transform: "translate(-951.934 -355.92)",
    fill: "#23a19f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17284",
    "data-name": "Path 17284",
    d: "M1507.194,1010.169c2.117,3.157,4.791,5.5,7.577,6.426l.483,4.9-.631.706c-2.451,3.343.594,7.429,3.789,6.872,8.1-.557,12.555-6.649,11.366-9.509l-1.189-1.04-1.077-6.909c.408-.074,3.231-2.154,4.086-2.526s1.969-2.266,1.857-4.123c-.149-1.857-2.9-.891-2.9-.891,2.86-5.089,6.278-9.4.743-13s-17.384-4.717-17.384-4.717l-7.243-1.56c1.189,2.3.929,10.438-.223,15.638-1.077,4.643-2.08,5.5.743,9.732",
    transform: "translate(-938.76 -191.175)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17285",
    "data-name": "Path 17285",
    d: "M1540.346,1060.7s-3.12,7.206-6.278,8.209-1.56.334-2.786.334l-.483-4.9c2.229.074,4.383-.334,9.546-3.64",
    transform: "translate(-954.752 -238.882)",
    fill: "#e98385",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(582.901 831.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 52.708,
    height: 69.72,
    transform: "translate(-0.761)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522",
    transform: "translate(565.11 788.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 37.033,
    height: 32.018,
    transform: "translate(-1.765 -0.893)",
    fill: "#2f394e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17288",
    "data-name": "Path 17288",
    d: "M1505.5,1161.891l4.829,15.9,8.506-13.112-.557-52.448,2.414-4.272-2.9-3.157-3.083,2.934,1.04,4.606c-3.492,9.4-8.172,37.293-10.252,49.55",
    transform: "translate(-938.849 -266.602)",
    fill: "#2f394e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17289",
    "data-name": "Path 17289",
    d: "M1517.181,1243.5l-3.343,1.077-7.466-1.3c-.817-.371-6.277-1.634-4.829.149,1,1.263,4.16,3.343,4.086,3.492-2.006,1.04-10.549,3.492-11.218,4.717-1.337,2.34,5.609.408,6.723.26.3-.037-4.68,2.006-4.569,2.637.074.334.891.854,2.117.631,1.523-.3,4.012-1.189,4.309-.966s-4.123,1.783-3.826,2.3a1.99,1.99,0,0,0,1.634.26c1.56-.334,3.826-1.3,4.2-1.151.408.149-2.675,1.189-2.675,1.56,0,.223.52.483.817.446,7.837-1.04,7.689-5.052,16.678-5.98,4.977-.557-.928-7.354-2.637-8.134",
    transform: "translate(-931.773 -353.152)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnershipArtwork);
export default __webpack_public_path__ + "static/media/partnership_artwork.be8031b6049908f807eaa65f3a355cf0.svg";
export { ForwardRef as ReactComponent };